import { QuantitySelectorComponent } from '@theme/component-quantity-selector';
import { fetchConfig } from '@theme/utilities';
import { ThemeEvents } from '@theme/events';

/**
 * A custom element that allows the user to select a quantity in the cart.
 */
class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  getEffectiveMax() {
    const { max } = this.getCurrentValues();
    return max;
  }

  updateButtonStates() {
    const { minusButton, plusButton } = this.refs;
    const { min, value } = this.getCurrentValues();
    const effectiveMax = this.getEffectiveMax();

    minusButton.disabled = value <= min;
    plusButton.disabled = effectiveMax !== null && value >= effectiveMax;
  }

  /**
   * 🔥 THIS WAS MISSING
   * Actually updates the Shopify cart
   */
  onQuantityChange() {
    const input = this.refs.quantityInput;
    const line = Number(input.dataset.cartLine);
    const quantity = Number(input.value);

    fetch('/cart/change.js', {
      ...fetchConfig('javascript'),
      body: JSON.stringify({
        line,
        quantity,
      }),
    }).then(() => {
      document.dispatchEvent(new Event(ThemeEvents.cartUpdate));
    });
  }
}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define(
    'cart-quantity-selector-component',
    CartQuantitySelectorComponent
  );
}
